var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9997,
    cy: 13.9999,
    rx: 11.6667,
    ry: 11.6667,
    fill: "#0e0333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 21.732 21.732 28 14 28C6.26799 28 0 21.732 0 14C0 6.26799 6.26799 0 14 0C21.732 0 28 6.26799 28 14ZM12.3806 21.4129L22.7677 11.0258C23.1204 10.6731 23.1204 10.1012 22.7677 9.74846L21.4904 8.47113C21.1377 8.11836 20.5658 8.11836 20.213 8.47113L11.7419 16.9421L7.78699 12.9872C7.43428 12.6345 6.86237 12.6345 6.5096 12.9872L5.23227 14.2645C4.87956 14.6172 4.87956 15.1892 5.23227 15.5419L11.1032 21.4128C11.456 21.7656 12.0279 21.7656 12.3806 21.4129V21.4129Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSuccess);
export default __webpack_public_path__ + "static/media/tick-success.1882e4db21a3fd3807d9205076f5510d.svg";
export { ForwardRef as ReactComponent };